import { useRef, useState } from "react";
import { backgroundImage, netFlixIcon } from "../utils/images";
import Header from "./Header";
import { validate } from "../utils/validate";
import { auth } from "../utils/firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateProfile,
} from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addUser } from "../utils/userSlice";

const Loginpage = () => {
  
  const [isLogin, setLogin] = useState(true);
  const [errorMessage, setErrormessage] = useState(null);
  const name = useRef(null);
  const email = useRef(null);
  const password = useRef(null);
  const dispatch=useDispatch()
  console.log(errorMessage);
  
  const handleSignInSingUP = () => {
    const message = validate(email.current.value, password.current.value);
    setErrormessage(message);
    if (message) return; //this means if i have error return the code
    if (!isLogin) {
      //SignUPCODE

      createUserWithEmailAndPassword(
        auth,
        email.current.value,
        password.current.value
      )
        .then((userCredential) => {
          // Signed up
          const user = userCredential.user;
          updateProfile(user, {
            displayName: name.current.value,
            photoURL:netFlixIcon,
          })
            .then(() => {
              const { uid, email, displayName, photoURL } = auth.currentUser;
              dispatch(
                addUser({
                  uid: uid,
                  email: email,
                  displayName: displayName,
                  photoURL: photoURL,
                })
              );
            })
            .catch((error) => {
              setErrormessage(error);
            });

          // ...
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          setErrormessage(errorCode + "-" + errorMessage);
          // ..
        });
    } else {
      //SIGNINCODE
      signInWithEmailAndPassword(
        auth,
        email.current.value,
        password.current.value
      )
        .then((userCredential) => {
          // Signed in
          const user = userCredential.user;
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          setErrormessage(errorCode + errorMessage);
        });
    }
  };
  return (
    <div className="">
      <Header />
    <div className="">
      <div className=" w-full ">
        <img className=" absolute h-screen w-full object-cover" src={backgroundImage}></img>
      </div>

      <form
        onSubmit={(e) => e.preventDefault()}
        className="w-3/4  max-w-xl 
         h-2/4 bg-gradient-to-b  from-black  p-12 mx-auto my-40 right-0 left-0 absolute"
      >
        <h1 className="text-3xl text-center text-white ">{isLogin?"Login":"Sign UP"}</h1>
        {!isLogin && (
          
         
          <input
            ref={name}
            type="text"
            className="p-2 m-2 w-full  "
            placeholder="Full Name"
          ></input>
          
          
        )}
        
        <input
          ref={email}
          type="text"
          className="p-2 m-2 w-full  "
          placeholder="Email"
        />
        <input
          ref={password}
          type=""
          className="p-2 m-2 w-full"
          placeholder="Password"
        />
        <p className=" mx-2 text-red-700 font-bold">{errorMessage}</p>
        <button
          onClick={handleSignInSingUP}
          className="rounded-xl p-2 m-2 w-full bg-red-700 text-white"
        >
          {isLogin ? "Login" : "Sign Up"}
        </button>

        <div className="flex ">
          <h1 className="text-white mx-2 mt-7">
            {isLogin ? "New to Neflix?" : "Already have a account?"}
          </h1>
          <button
            onClick={() => {
              setLogin(!isLogin)
            
            }}
            className="text-white font-bold mt-7"
          >
            {isLogin ? "Sign Up" : "Sign In"}
          </button>
        </div>
      </form>
      </div>
    </div>
  );
};
export default Loginpage;
